/**
 * @generated SignedSource<<f367743e7ed7efb54a38311904e05114>>
 * @relayHash 8e5e866c8ce8d1cb963ef62edd739b94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 18a27afe1a8aa48e2b295eb57b00b2804ec99dd028f5aa61b14ebdb521b94793

import type { ConcreteRequest } from 'relay-runtime';
export type DeleteInlineCommentInput = {
  commentId: string;
  step?: Step | null;
};
export type Step = {
  from?: AGG$Long | null;
  mark: Mark;
  pos?: AGG$Long | null;
  to?: AGG$Long | null;
};
export type Mark = {
  attrs?: MarkAttribute | null;
  type: string;
};
export type MarkAttribute = {
  annotationType: string;
  id: string;
};
export type CommentDeleteInlineCommentMutationWithStepMutation$variables = {
  input: DeleteInlineCommentInput;
};
export type CommentDeleteInlineCommentMutationWithStepMutation$data = {
  readonly deleteInlineComment: boolean | null;
};
export type CommentDeleteInlineCommentMutationWithStepMutation = {
  response: CommentDeleteInlineCommentMutationWithStepMutation$data;
  variables: CommentDeleteInlineCommentMutationWithStepMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteInlineComment"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CommentDeleteInlineCommentMutationWithStepMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentDeleteInlineCommentMutationWithStepMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8e5e866c8ce8d1cb963ef62edd739b94",
    "id": "18a27afe1a8aa48e2b295eb57b00b2804ec99dd028f5aa61b14ebdb521b94793",
    "metadata": {},
    "name": "CommentDeleteInlineCommentMutationWithStepMutation",
    "operationKind": "mutation",
    "text": "mutation CommentDeleteInlineCommentMutationWithStepMutation($input:DeleteInlineCommentInput!){deleteInlineComment(input:$input)}"
  }
};
})();

(node as any).hash = "8bc2a29aa8ca1e95a28cad450493e297";

export default node;
